import { get, isArray } from 'lodash-es';
const convertToFile = async _ref => {
  let {
    dataURI,
    fileName,
    allowFile
  } = _ref;
  const allowPdf = allowFile.includes('pdf');
  if (!dataURI || typeof dataURI !== 'string') return null;
  if (allowPdf) {
    if (!dataURI.startsWith('data:image/') && !dataURI.startsWith('data:application/pdf')) {
      return null;
    }
  } else if (!dataURI.startsWith('data:image/')) {
    return null;
  }
  const res = await fetch(dataURI, {
    mode: 'no-cors'
  });
  const buf = await res.arrayBuffer();
  const file = new File([buf], fileName, {
    type: dataURI.startsWith('data:image/') ? 'image/png' : 'application/pdf'
  });
  return file;
};
const uploadImgFunc = async _ref2 => {
  let {
    images,
    address,
    uploadApi,
    allowFile
  } = _ref2;
  try {
    if (!images || images.length === 0) {
      return [];
    }
    const postFormData = new FormData();
    const uploadFiles = [];
    const promises = images.map((image, index) => convertToFile({
      dataURI: get(image, 'data_url'),
      fileName: get(image, 'file.name'),
      allowFile
    }));

    // Wait for all promises to complete
    const files = await Promise.all(promises);
    files.forEach((file, index) => {
      if (file) {
        postFormData.append('img', file);
        uploadFiles.push(index);
      }
    });
    postFormData.append('address', address);
    const uploadResult = await uploadApi({
      data: postFormData
    });
    return get(uploadResult, 'img', []);
  } catch (error) {
    throw new Error(error);
    // You can also throw the error if you want the calling function to be aware of it.
    // throw error;

    // Or you can return a default/failure value.
  }
};
const imgFileTypes = ['png', 'jpg', 'jpeg'];
const parseFilenames = urls => {
  if (!isArray(urls)) {
    return null;
  }
  return urls.map((url, index) => {
    let extension;
    let name;
    if (!url.startsWith('data:')) {
      var _partsOfFilename$, _nameParts$slice;
      const parts = url.split('/');
      const filenameWithTimestamp = parts[parts.length - 1];
      const partsOfFilename = filenameWithTimestamp.split('.');
      extension = partsOfFilename.pop();
      const nameParts = (_partsOfFilename$ = partsOfFilename[0]) === null || _partsOfFilename$ === void 0 ? void 0 : _partsOfFilename$.split('-');
      name = nameParts === null || nameParts === void 0 || (_nameParts$slice = nameParts.slice(0, nameParts.length - 1)) === null || _nameParts$slice === void 0 ? void 0 : _nameParts$slice.join('-');
    } else {
      let fileType;
      const match = url.match(/data:[a-z]+\/([a-z]+);base64,/);
      if (match && match.length > 1) {
        [, fileType] = match; // 'pdf' 或 'png'
      }
      extension = fileType;
      name = "testUpload ".concat(index);
    }
    return {
      name,
      extension,
      img: url
    };
  });
};
export { imgFileTypes, parseFilenames, uploadImgFunc };